module.exports = __webpack_public_path__ + "placa_col_estof_10x_s_entr_s_juros.png?0e5079805f3aaefbb0bf59a6d1c4e928";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/placa_col_estof_10x_s_entr_s_juros.png
// module id = 121
// module chunks = 0